import type { IDonorMentorCannedResponse } from "@nkr/models/dash/donor-mentor-canned-response";
import { Table } from "react-bootstrap";

interface IProps {
    data: IDonorMentorCannedResponse[],
    setSelectedRow: (selected: IDonorMentorCannedResponse) => void,
}

export const DonorMentorCannedResponsesGrid = (props: IProps) => {
    if (!props.data.length) {
        return <div>You have not created any donor mentor canned responses yet.</div>;
    }

    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Email Subject</th>
                </tr>
            </thead>
            <tbody>
                {props.data.map(item => (
                    <tr key={item.id} onClick={() => props.setSelectedRow(item)} style={{ cursor: "pointer" }}>
                        <td>{item.name}</td>
                        <td>{item.emailSubject}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};
